module.exports = __webpack_public_path__ + "static/ext2-e5d720ced9579f527e1738ac3b41bc90.png";